import React from "react";
import { FieldArray } from "formik";
import { uniqId } from "../../utils/commonHelpers";
import { TextField, Button } from "@material-ui/core";
import { getIn } from "formik";
import { Number } from "../../utils/Number";
import { TextMaskCustom } from "../../utils/TextMaskCustom";
import AutoCompleteStates from "../FormComponents/AutoCompleteStates";

const otherDriverInsuranceInfo = [
  {
    label: "Name of Carrier",
    name: "nameOfCarrier",
    type: "text",
  },
  // {
  //   label: "Name of Insured",
  //   name: "insurerName",
  //   type: "text",
  // },
  {
    label: "Policyholder Name",
    name: "policyHolderName",
    type: "text",
  },
  {
    label: "Policy Number",
    name: "policyNo",
    type: "text",
  },
  {
    label: "Claim Number",
    name: "claimNo",
    type: "text",
  },
  {
    label: "Adjuster",
    name: "adjuster",
    type: "text",
  },

  {
    label: "Address",
    name: "addressLine1",
    type: "text",
  },

  {
    label: "City",
    name: "city",
    type: "text",
  },
  {
    label: "State",
    name: "state",
    type: "autoComplete",
  },
  {
    label: "ZIP Code",
    name: "zipCode",
    type: "number",
  },

  {
    label: "Phone",
    name: "phone",
    type: "phone",
  },
];

function OtherDriversInsurance({ values, touched, error, handleChange, errors, setFieldValue }) {
  return (
    <div className="row other-drivers-insurence">
      <div className="col-lg-12">
        <h5>Other Driver's Auto Insurance </h5>
      </div>
      <div className="col-lg-12">
        <div>
          <FieldArray name="otherDriverInsuranceFields">
            {(insProps) => {
              const { push, remove, form } = insProps;
              const { values } = form;
              const { otherDriverInsuranceFields } = values;
              return (
                <div>
                  {otherDriverInsuranceFields.map((ins, index) => {
                    return (
                      <div
                        key={ins.id}
                        className={
                          index < otherDriverInsuranceFields.length - 1 ? "border-btm-field" : ""
                        }
                      >
                        <div className="row">
                          <div className="col-12">
                            <div className="row my-3">
                              {otherDriverInsuranceInfo.map(
                                ({ label, name, type, required = false }, ind) => {
                                  if (type === "text") {
                                    return (
                                      <div className="form-group col-md-6 col-lg-4" key={ind}>
                                        <TextField
                                          label={label}
                                          name={`otherDriverInsuranceFields[${index}][${name}]`}
                                          onChange={handleChange}
                                          // value={values[name]}
                                          aria-label="text-field"
                                          fullWidth
                                          error={Boolean(
                                            getIn(
                                              touched,
                                              `otherDriverInsuranceFields[${index}][${name}]`
                                            ) &&
                                              getIn(
                                                errors,
                                                `otherDriverInsuranceFields[${index}][${name}]`
                                              )
                                          )}
                                          helperText={
                                            getIn(
                                              touched,
                                              `otherDriverInsuranceFields[${index}][${name}]`
                                            ) &&
                                            getIn(
                                              errors,
                                              `otherDriverInsuranceFields[${index}][${name}]`
                                            ) &&
                                            getIn(
                                              errors,
                                              `otherDriverInsuranceFields[${index}][${name}]`
                                            )
                                          }
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          inputProps={{
                                            maxLength:
                                              name === "nameOfCarrier" ||
                                              name === "addressLine1" ||
                                              name === "policyHolderName" ||
                                              name === "adjuster"
                                                ? 50
                                                : 35,
                                          }}
                                          // margin="dense"
                                        ></TextField>
                                      </div>
                                    );
                                  } else if (type === "number" || type === "phone") {
                                    return (
                                      <div className="form-group col-md-6 col-lg-4" key={ind}>
                                        <TextField
                                          label={label}
                                          name={`otherDriverInsuranceFields[${index}][${name}]`}
                                          onChange={handleChange}
                                          // value={values[name]}
                                          aria-label="text-field"
                                          fullWidth
                                          error={Boolean(
                                            getIn(
                                              touched,
                                              `otherDriverInsuranceFields[${index}][${name}]`
                                            ) &&
                                              getIn(
                                                errors,
                                                `otherDriverInsuranceFields[${index}][${name}]`
                                              )
                                          )}
                                          helperText={
                                            getIn(
                                              touched,
                                              `otherDriverInsuranceFields[${index}][${name}]`
                                            ) &&
                                            getIn(
                                              errors,
                                              `otherDriverInsuranceFields[${index}][${name}]`
                                            ) &&
                                            getIn(
                                              errors,
                                              `otherDriverInsuranceFields[${index}][${name}]`
                                            )
                                          }
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          InputProps={{
                                            inputComponent: type === "phone" ? TextMaskCustom : Number,
                                          }}
                                          inputProps={{ maxLength: type === "number" ? 5 : undefined }}
                                          // margin="dense"
                                        ></TextField>
                                      </div>
                                    );
                                  } else if (type === "autoComplete") {
                                    return (
                                      <div className="form-group col-md-6 col-lg-4" key={name + ind}>
                                        <AutoCompleteStates
                                          label={label}
                                          name={`otherDriverInsuranceFields[${index}][${name}]`}
                                          onChange={(e, value) => {
                                            if (value) {
                                              setFieldValue(
                                                `otherDriverInsuranceFields[${index}][${name}]`,
                                                value.code
                                              );
                                            } else {
                                              setFieldValue(
                                                `otherDriverInsuranceFields[${index}][${name}]`,
                                                ""
                                              );
                                            }
                                          }}
                                          // value={values.otherDriverInsuranceFields[${index}][${name}]}
                                          aria-label="auto-complete"
                                          fullWidth
                                          error={Boolean(
                                            getIn(
                                              touched,
                                              `otherDriverInsuranceFields[${index}][${name}]`
                                            ) &&
                                              getIn(
                                                errors,
                                                `otherDriverInsuranceFields[${index}][${name}]`
                                              )
                                          )}
                                          helperText={
                                            getIn(
                                              touched,
                                              `otherDriverInsuranceFields[${index}][${name}]`
                                            ) &&
                                            getIn(
                                              errors,
                                              `otherDriverInsuranceFields[${index}][${name}]`
                                            ) &&
                                            getIn(
                                              errors,
                                              `otherDriverInsuranceFields[${index}][${name}]`
                                            )
                                          }
                                          required={required}
                                        />
                                      </div>
                                    );
                                  }
                                }
                              )}
                            </div>
                          </div>
                          <div className="col-lg-12">
                            {
                              <Button
                                className="add-btn mb-3"
                                margin="normal"
                                type="button"
                                color="primary"
                                variant="outlined"
                                onClick={() => remove(index)}
                              >
                                {/* <DeleteOutlinedIcon /> */} delete
                              </Button>
                            }
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <div className="row mx-0">
                    <div className="col-12 text-center">
                      <Button
                        className={
                          otherDriverInsuranceFields && otherDriverInsuranceFields.length >= 4
                            ? "add-btn-disabled mt-3"
                            : "add-btn mt-3"
                        }
                        margin="normal"
                        type="button"
                        color="primary"
                        variant="outlined"
                        // type="button"
                        disabled={otherDriverInsuranceFields && otherDriverInsuranceFields.length >= 4}
                        onClick={() =>
                          push({
                            id: uniqId(),
                            insuredType: "Other",
                            nameOfCarrier: "",
                            insurerName: "",
                            policyNo: "",
                            claimNo: "",
                            adjuster: "",
                            phone: "",
                            addressLine1: "",
                            city: "",
                            state: "",
                            zipCode: "",
                          })
                        }
                      >
                        Add Insurance +
                      </Button>
                    </div>
                  </div>
                </div>
              );
            }}
          </FieldArray>
        </div>
      </div>
    </div>
  );
}

export default React.memo(OtherDriversInsurance);
